import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoadSimulationFilter {
  user?: { id: any; name: string };
  customer?: { id: any; name: string };
  region?: { id: any; name: string };
  project?: { id: any; name: string };
  simulation?: { id: any; name: string };
}

@Injectable({ providedIn: 'root' })
export class LoadSimulationService {
  private allSimulations: any[] = [];
  private filters: LoadSimulationFilter = {};

  private filteredSimulationsSubject = new BehaviorSubject<any[]>([]);
  filteredSimulations$ = this.filteredSimulationsSubject.asObservable();

  private selectedSimulationSubject = new BehaviorSubject<any>(null);
  selectedSimulation$ = this.selectedSimulationSubject.asObservable();

  setSimulations(simulations: any[]) {
    this.allSimulations = simulations;
    this.applyFilters();
  }

  setFilters(filters: LoadSimulationFilter) {
    this.filters = filters;
    this.applyFilters();
  }

  setSelectedSimulation(simulation: any) {
    this.selectedSimulationSubject.next(simulation);
  }

  getSelectedSimulationValue(): any {
    return this.selectedSimulationSubject.getValue();
  }

  private applyFilters() {
    const filtered = this.allSimulations.filter(sim => {
      return (!this.filters.user || sim.user.id === this.filters.user.id)
        && (!this.filters.customer || sim.customer.id === this.filters.customer.id)
        && (!this.filters.region || sim.region.id === this.filters.region.id)
        && (!this.filters.project || sim.project.id === this.filters.project.id)
        && (!this.filters.simulation || sim.id === this.filters.simulation.id);
    });

    this.filteredSimulationsSubject.next([...filtered]);
  }
}
